// Chakra Imports
import {
  Avatar,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
  useToast,
} from '@chakra-ui/react';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
// Assets
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../auth-context/auth.context';
import AuthApi from '../../api/auth';
import routes from 'routes.js';

export default function HeaderLinks(props) {
  const history = useHistory();
  let { user, removeUserAuth } = useAuth();
  const toast = useToast();
  const toastIdRef = React.useRef();
  console.log('user from context', user);
  const { secondary } = props;
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
  );
  const handleLogout = async () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      let response = await AuthApi.Logout();
      toastIdRef.current = toast({
        title: response.data?.message || 'Logged out Successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } catch (err) {
      console.error('Logout API failed', err);
    } finally {
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('accesstoken');
      sessionStorage.removeItem('refreshtoken');
      sessionStorage.removeItem('permissions');
      removeUserAuth();
      // window.location.reload();
      return history.push('/auth/sign-in');
    }
  };
  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems='center'
      justifyContent='space-between'
      flexDirection='row'
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p='10px'
      borderRadius='30px'
      boxShadow={shadow}
    >
      <SidebarResponsive routes={routes} />
      <Menu>
        <MenuButton p='0px'>
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color='white'
            name={user?.name}
            bg='#11047A'
            size='sm'
            w='40px'
            h='40px'
          />
        </MenuButton>
        {user?.name && (
          <MenuList
            boxShadow={shadow}
            p='0px'
            mt='10px'
            borderRadius='20px'
            bg={menuBg}
            border='none'
          >
            <Flex w='100%' mb='0px'>
              <Text
                ps='20px'
                pt='16px'
                pb='10px'
                w='100%'
                borderBottom='1px solid'
                borderColor={borderColor}
                fontSize='sm'
                fontWeight='700'
                color={textColor}
              >
                👋&nbsp; , {user?.name} <br />
                <span fontWeight='normal'>{user?.email}</span>
              </Text>
            </Flex>

            <Flex flexDirection='column' p='10px'>
              <MenuItem
                _hover={{ bg: 'none' }}
                _focus={{ bg: 'none' }}
                color='red.400'
                borderRadius='8px'
                px='14px'
                onClick={handleLogout}
              >
                <Text fontSize='sm'>Log out</Text>
              </MenuItem>
            </Flex>
          </MenuList>
        )}
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
